'use strict';

import userLookupTemplate from './userLookup.directive.html';

export default angular
  .module('maestro.directives.components.user-lookup', [])

  .directive('userLookup', ($filter) => {
    const $t = $filter('translate');
    return {
      restrict: 'E',
      template: userLookupTemplate,
      scope: {
        onUserSelect: '&', // callback for user select event
        onUserSearch: '&', // callback for search user button click
        usersExternal: '=users', // list of users to display
        loading: '=', // external loading indicator
        validationRules: '@', // Array<{}>, form validation rules
        inputId: '@', // Search input id,
        scrollFix: '=', // Scroll to search results, bool
        searchHeader: '@',
        hideNotFoundMsg: '=',
        activeTab: '=',
      },
      controller: ($scope,
                   $element,
                   $rootScope,
                   $state) => {

        angular.extend($scope, {
          onSearchUsersButtonClick: onSearchUsersButtonClick,
          onSelectUser: onSelectUser,
          closeHint: closeHint,
          inputId: $scope.inputId || 'input-user-search',
          searchHeader: $scope.searchHeader || 'users.lookup.selectUser',
          clearAllUsers: clearAllUsers,
          newUser: newUser,
        });

        let formElement = $element.find('form')[0];
        init();

        function init() {
          $('#' + $scope.inputId).trigger('blur');
          $scope.$watch('usersExternal', () => {
            onUsersChange();
          });

          // Form validation options
          $scope.validationRules = $scope.validationRules || [
            {
              type: 'empty',
              prompt: $t('prompt.empty')
            }
          ];

          let options = {};
          options[$scope.inputId] = {
            rules: $scope.validationRules
          };
          $(formElement).form({
            inline: true,
            fields: options
          });
        }

        function onSearchUsersButtonClick() {
          $(formElement).form('validate form');
          if (!$(formElement).form('is valid') || !$scope.searchStr) {
            return;
          }
          $scope.onUserSearch({ searchTerm: $scope.searchStr });
          $scope.lastSearchStr = $scope.searchStr;
        }

        function onSelectUser(user) {
          if (user) {
            $scope.lastSelectedUser = user;
            $scope.onUserSelect({ user: user });
          }
        }

        function onUsersChange() {
          $scope.lastSelectedUser = void 0;

          // Scroll to results
          if ($scope.scrollFix) {
            $('html, body').animate({
              scrollTop: parseInt($element.offset().top) - 100
            }, 500);
          }

          let extUsers = $scope.usersExternal;

          if (!extUsers) {
            $scope.users = [];
          } else if (angular.isArray(extUsers)) {
            $scope.users = extUsers.slice(0);
          } else if (extUsers.users && angular.isArray(extUsers.users)) {
            $scope.users = extUsers.users.slice(0);
          } else {
            $scope.users = [];
          }
        }

        function closeHint() {
          $scope.searchStr = '';
          $('#' + $scope.inputId).trigger('focus');
        }

        /**
         * Redirect to create new user page,
         * with optional credentials from the search field
         */
        function newUser($event) {
          // TODO: Use search field value to force the phone or email
          $rootScope.$emit('refreshChooseMenuEvent', 'users');
          $state.go('main.users.new', {
            from: 'location',
            fromTab: $scope.activeTab,
          });
        }

        function clearAllUsers() {
          $scope.users = [];
          closeHint();
        }

      }
    };
  })

  .name;
